/**
 * Branch IDs that should route API calls through the UK API URL.
 * Matched case-insensitively.
 */
const UK_BRANCH_IDS = ["uk", "en-gb"];

/**
 * Returns true if the given lltsBranchId designates the UK branch.
 */
export const isUkBranchId = (branchId: string | undefined): boolean => {
  if (!branchId) {
    return false;
  }
  return UK_BRANCH_IDS.includes(branchId.toLowerCase());
};

/**
 * Extracts the lltsBranchId from a URL pathname.
 * The path format is /:lltsBranchId?/... so the branch id is the first non-empty segment.
 */
export const getBranchIdFromPathname = (pathname: string): string | undefined => {
  const pathParts = pathname.split("/").filter(part => part.length > 0);
  return pathParts[0];
};

/**
 * Resolves the API base URL for the given lltsBranchId.
 * Returns VITE_API_URL_OVERRIDE_UK for UK branch ids when defined, otherwise VITE_API_URL_OVERRIDE.
 * Returns undefined if neither env var is set so callers can fall back to the generated default.
 */
export const resolveApiBaseUrl = (branchId: string | undefined): string | undefined => {
  if (isUkBranchId(branchId) && import.meta.env.VITE_API_URL_OVERRIDE_UK) {
    return import.meta.env.VITE_API_URL_OVERRIDE_UK;
  }
  return import.meta.env.VITE_API_URL_OVERRIDE;
};
